meedy.factory('meedy.patientModel', ['$rootScope', 'meedy.baseModel', 'meedy.patientService', '$q',
    function($rootScope, baseModel, patientService, $q) {

        function PatientModel() {

            this.getDataPage = function(criteria) {
                return patientService.getDataPage(criteria).then(
                    function (dataPage) {
                        return dataPage;
                    },
                    function(error) {
                        $q.reject(error);
                    }
                )
            }
        }

        return new PatientModel();
    }
]);
